import {
	IsSpaceOptionOrZero,
	SpaceOptionsOrZero,
} from "../../Space/Space.types";
import { ViewportResult } from "../../../../hooks/useViewport/useViewport.types";
import { BreakpointOptions } from "../../../../types/theming";

export function resolveGuttersSpaceOption(
	value: SpaceOptionsOrZero | undefined,
	ssrContextBreakpoint: BreakpointOptions | null,
	viewport: ViewportResult
): SpaceOptionsOrZero {
	// Firstly, check for for an explicitly set gutter space.
	if (IsSpaceOptionOrZero(value)) {
		return value;
	}

	// Check for server side context breakpoint, and prioritise this over viewport if exists.
	if (ssrContextBreakpoint) {
		const OPTIONS: BreakpointOptions[] = ["xs", "sm", "md", "lg"];
		if (
			OPTIONS.findIndex(
				(bp: BreakpointOptions) => bp === ssrContextBreakpoint
			) > -1
		) {
			return "md";
		}
		return "lg";
	}

	// Otherwise, no gutters explicity specified, and no server side context breakpoint, so apply defaults.
	return viewport.lessThan.xl ? "md" : "lg";
}
